"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndPointsConfig = void 0;
var EndPointsConfig = /** @class */ (function () {
    function EndPointsConfig() {
        this.gateWayMSurl = '/msapi';
        this.nodeGatewayMSurl = '/msapi/sales';
        this.onlineCartOrchSummaryURL = '/onlinecartorch/v1/cart-details/cartsummary';
        this.autobillPayURL = this.gateWayMSurl + "/cart/v1/orderbuilder/autobillpay";
        this.postLoginStepMSAPI = this.gateWayMSurl + "/checkout/login/v1/";
        this.priceinfoAPI = this.gateWayMSurl + "/cart/v1/priceInfo/";
        this.cartSummaryMSAPI = this.gateWayMSurl + "/cart/v1/";
        this.cartSummaryMSAPIURL = this.gateWayMSurl + "/cart/v1/summary";
        this.validateCredentials = this.gateWayMSurl + "/login/unauth/service/v1/validateCredential";
        this.promoCodePOSTAPI = this.gateWayMSurl + "/cart/v1/coupon";
        this.promoCodeForWirelessAPI = this.gateWayMSurl + "/cart/v1/rewardCard";
        this.repCodePOSTAPI = this.gateWayMSurl + "/cart/v1/repCode";
        this.storeDetails = this.gateWayMSurl + "/wirelessorder/v1/c2sdetails/storebyid?storeId=";
        this.insuranceDetails = this.nodeGatewayMSurl + "/buywirelessorchestrationms/v1/auth/flowdetails?insuranceDetails=true";
        this.furtureBillsNewMSAPI = this.gateWayMSurl + "/cart/v1/futurebillestimate";
        this.emptyCartMSAPI = this.gateWayMSurl + "/cart/v1/remove/";
        this.emptyCommonCartMSAPI = this.nodeGatewayMSurl + "/onlinecartorch/v1/cart-operations/remove/";
        this.addToCartMSAPI = this.gateWayMSurl + "/cart/v1/";
        this.tradeInPromosAPI = this.gateWayMSurl + "/cart/v1/tradeinpromos";
        this.addToCartMSAPIOrchestration = this.nodeGatewayMSurl + "/onlinecartorch/v1/cart-operations/addtocart";
        this.addToCommonCartMSAPI = this.nodeGatewayMSurl + "/onlinecartorch/v1/cart-operations/addtocart";
        this.getUserCurrentState = this.gateWayMSurl + "/login/unauth/service/v1/getUserCurrentState/sales/account-in-focus?filter=wireless";
        this.saveCartApiUrl = this.gateWayMSurl + "/cart/v1/save";
        this.retrieveCartUrl = this.gateWayMSurl + "/cart/v1/retrieve";
        this.ckavapiurl = this.gateWayMSurl + "/checkout/v1/address/validateServiceAddress";
        this.wirelessProductRexMSAPI = this.gateWayMSurl + "/wirelessproductrecommendationms/v1/recommendation/getPrepaidDetails";
        this.wirelessCMSAPI = this.gateWayMSurl + "/idp-content-orchestration/v1/idpcms/sales/buy/wireless";
        this.loggingMSAPI = this.gateWayMSurl + "/reporting/v1/log/event";
        this.featureAPI = this.gateWayMSurl + "/ixp-allocation-manager-service/v1/allocations?teams=checkout-ui,pands,wsce,cart&targetPath=/msapi";
        this.idmFeatureAPI = this.gateWayMSurl + "/ixp-allocation-manager-service/v1/allocations?user_id=user-001&user_recognized=false&teams=idm";
        this.closerCouponAPI = this.gateWayMSurl + "/cart/v1/closerCoupon";
        this.shareCartAPI = this.gateWayMSurl + "/cart/v1/shareCart";
        this.validateZip = this.gateWayMSurl + "/cart/v1/zipCode";
        this.validateZipForBsse = "" + this.nodeGatewayMSurl + this.onlineCartOrchSummaryURL + "?repriceEventType=zipcode&zipCode=";
        this.spoMSAPI = this.gateWayMSurl + "/salesproductorchestration/v1/";
        this.spoMSAPICommonCartMSAPI = this.nodeGatewayMSurl + "/onlinecartorch/v1/offers/productInfo";
        this.billCodeMSAPI = this.nodeGatewayMSurl + "/uis/v1/dates/billcodes";
        this.updateOspreyQuantityInCart = this.gateWayMSurl + "/cart/v1/updateOspreyDevice";
        this.monthlySavingsAPI = this.gateWayMSurl + "/cart/v2/planpriceinfo";
        this.initializeCartAPI = this.gateWayMSurl + "/cart/v1/intializeCart";
        this.migrateCartAPI = this.gateWayMSurl + "/cart/v1/migrateCart";
        this.monthlySavingsCommonCartMSAPI = this.nodeGatewayMSurl + "/onlinecartorch/v1/cart-details/pricecomparisoninfo";
        this.repriceCartUrl = this.gateWayMSurl + "/cart/v1/repriceCart";
        this.edsEncryptionForActivation = this.gateWayMSurl + '/onlinesalesorchestration/devices-papi/v1/watchactivation/encrypttoken';
        this.cartInfoApi = this.gateWayMSurl + "/cart/v1/reporting/cartinfo";
        this.deviceSKUMapping = '/idpcms/sales/prod/wireless/devices.skumapping.js';
        this.realtimePaymentErrors = ['eV1385', 'eV2858'];
        this.realtimeBillingErrors = ['eV2526'];
        this.catalogAppleImage = 'IMG_appleTV@2x.png';
        this.catalogOspreyImage = 'IMG_osprey@2x.png';
        this.catalogRokuImage = 'IMG_roku@2x.png';
        this.equipmentMapper = {
            data: {
                equipments: [
                    {
                        image: 'IMG_amazonFireStick@2x.png',
                        productSku: '7457099420',
                    },
                    {
                        image: this.catalogAppleImage,
                        productSku: '7457497502',
                    },
                    {
                        image: this.catalogAppleImage,
                        productSku: '724680378',
                    },
                    {
                        image: this.catalogAppleImage,
                        productSku: '3113494042',
                    },
                    {
                        image: this.catalogAppleImage,
                        productSku: '724680395',
                    },
                    {
                        image: this.catalogOspreyImage,
                        productSku: '7456863975',
                    },
                    {
                        image: this.catalogOspreyImage,
                        productSku: '729760556',
                    },
                    {
                        image: this.catalogOspreyImage,
                        productSku: '60075',
                    },
                    {
                        image: this.catalogRokuImage,
                        productSku: '7456863876',
                    },
                    {
                        image: this.catalogRokuImage,
                        productSku: '718118370',
                    },
                    {
                        image: this.catalogRokuImage,
                        productSku: '725764108',
                    },
                    {
                        image: this.catalogAppleImage,
                        productSku: '7456863964',
                    },
                ],
            },
        };
    }
    return EndPointsConfig;
}());
exports.EndPointsConfig = EndPointsConfig;
exports.default = new EndPointsConfig();
//# sourceMappingURL=EndPointsConfig.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/api/EndPointsConfig.js
// module id = 570
// module chunks = 8